import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography } from '@mui/material';
import useStyles from './styles';
import HelpIcon from '../../../../assets/icons/help-icon';

import { loadStatic } from '../../../../static';

const Help = (properties: { userLink?: string }) => {
    const { userLink } = properties;
    const classes = useStyles();

    const [sharepointBaseUrl, setSharepointBaseUrl] = useState("");

    useEffect(() => {
        loadStatic().then(({ SHAREPOINT_BASE_URL }) => {
            setSharepointBaseUrl(SHAREPOINT_BASE_URL);
            return null;
        }).catch(() => {
        });
    }, []);

    /* eslint-disable unicorn/consistent-function-scoping */
    const openSharePoint = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        window.open(sharepointBaseUrl + userLink);
    }

    return (
        <Box
            width="100%" display="flex" justifyContent="center" alignItems="center"
        >
            <IconButton
                id="infoButton"
                color="primary"
                onClick={(event) => { openSharePoint(event) }}
                size="large"
            >
                <HelpIcon />
            </IconButton >
            <Typography variant="body1" marginLeft="-10px">
                Help
            </Typography>
        </Box>

    );
}
export { Help };